import { getUserLang } from '@/i18n/utils';

export const normalizePrice = (price: number | string) => {
  const cleanPrice =
    typeof price === 'string' ? parseFloat(price.replace('$', '')) : price;

  return (
    new Intl.NumberFormat(getUserLang().detectedValue, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      currencyDisplay: 'narrowSymbol'
    })
      .format(cleanPrice)
      .replace('$', '')
      .trim() + ' USD'
  );
};

export const normalizePriceDollar = (price: number | string) => {
  const cleanPrice =
    typeof price === 'string' ? parseFloat(price.replace('$', '')) : price;

  return (
    '$' +
    new Intl.NumberFormat(getUserLang().detectedValue, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      currencyDisplay: 'narrowSymbol'
    })
      .format(cleanPrice)
      .replace('$', '')
      .trim()
  );
};
